import { Link } from "gatsby";
import React from "react";

export default function RecentCard({ data }) {
  return (
    <li className="post-thumbnail-content">
      {data.hero?.asset ? (
        <img src={data.hero?.asset?.url} alt="post image" />
      ) : (
        <div className="text-thumb" />
      )}
      <div className="post-title-date">
        <h6>
          <Link to={`/${data?.pageSlug.current}`}>{data.title}</Link>
        </h6>
        {/* <span className="posted-on">
          By <a href="#">{data?.author?.name}</a>
        </span> */}
      </div>
    </li>
  );
}
